<template>
  <button class="button" :class="classes">
    <slot />
  </button>
</template>

<script>
export default {
  name: "Button",
  props: {
    primary: {
      type: Boolean,
      default: false
    },
    secondary: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return {
        "--primary": this.primary,
        "--secondary": this.secondary
      };
    }
  }
};
</script>

<style lang="scss">
.button {
  font-weight: bold;
  padding: 1.5rem 3rem;
  border-radius: get($radius, "round");
  background: rgba(0, 0, 0, 0);
  border: 1px solid get($colors, "black");
  @media #{$md-and-up} {
    cursor: pointer;
  }
  &.--primary {
    color: get($colors, "white");
    background: get($theme, "primary");
    border-color: get($theme, "primary");
  }
  &.--secondary {
    color: get($colors, "white");
    background: get($theme, "secondary");
    border-color: get($theme, "secondary");
  }
}
</style>
